//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 22/05/2025
// Version       : 1
// Description   : Tabla que muestra los errores y falta de datos en los reportes
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import { useState, useEffect, useMemo } from "react";
import { UrlApi } from "../../../services/apirest";
import { MaterialReactTable } from "material-react-table";
// TABLA EN ESPAÑOL
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  Box,
  Typography,
  ThemeProvider,
  createTheme,
  useTheme,
} from "@mui/material";
import Navbar from "../../Navbar";

function AnomaliasReportes() {
  const globalTheme = useTheme();

  const [anomalias, setAnomalias] = useState([]);

  const ObtenerAnomalias = () => {
    fetch(UrlApi + "/vehiculos_reporte_combustibles/anomalias")
      .then((data) => data.json())
      .then((data) => setAnomalias(data));
  };

  useEffect(() => {
    ObtenerAnomalias();
  }, []);

  //*************************************************************************************************************************************/
  // ----------- TABLA ---------------
  const customLocalization = {
    ...MRT_Localization_ES,
    body: {
      ...MRT_Localization_ES.body,
      noData: "No hay registros para mostrar",
    },
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "patente_reporte",
        header: "Patente (Reportes)",
        Cell: ({ cell }) => cell.getValue() || "-",
        size: 80,
      },
      {
        accessorKey: "patente",
        header: "Patente (Vehículos)",
        Cell: ({ cell }) => cell.getValue() || "-",
        size: 80,
      },
      {
        accessorKey: "modelo",
        header: "Modelo",
        Cell: ({ cell }) => cell.getValue() || "-",
        size: 160,
      },
      {
        accessorKey: "marca",
        header: "Marca",
        Cell: ({ cell }) => cell.getValue() || "-",
        size: 100,
      },
      {
        accessorKey: "sucursal",
        header: "Sucursal",
        Cell: ({ cell }) => cell.getValue() || "-",
        size: 100,
      },
      {
        accessorKey: "total_cantidad",
        header: "Cantidad Total",
        size: 100,
      },
    ],
    []
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
      "& .MuiSvgIcon-root": {
        color: "white", // color de los íconos
      },
    },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { backgroundColor: "#ffffff" },
    variant: "outlined",
    size: "small",
  };

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  //*************************************************************************************************************************************/

  return (
    <>
      <Navbar />
      <Box
        sx={{
          marginTop: "20px",
          marginBottom: "25px",
          marginLeft: "40px",
          marginRight: "40px",
        }}
      >
        <ThemeProvider theme={tableTheme}>
          <MaterialReactTable
            columns={columns}
            data={anomalias}
            initialState={initialState}
            autoResetPageIndex={false}
            enableDensityToggle={false}
            enableFullScreenToggle={false}
            enableColumnFilters={false}
            enableHiding={false}
            localization={customLocalization}
            enableRowSelection={false}
            enableGlobalFilter
            muiTableHeadCellProps={tableHeadCellProps}
            muiSearchTextFieldProps={muiSearchTextFieldProps}
            muiTableBodyCellProps={({}) => ({
              align: "left",
              sx: {
                color: "black",
                borderColor: "black",
              },
            })}
            renderTopToolbarCustomActions={() => (
              <>
                <Typography variant="poster" fontSize={26}>
                  Anomalías en los Reportes
                </Typography>
              </>
            )}
          />
        </ThemeProvider>
      </Box>
    </>
  );
}

export default AnomaliasReportes;
